import { useState } from "react";
import { Link } from "react-router-dom";
import { LogIn, ArrowLeft } from "lucide-react";
import { useAuth } from "@/App";

export default function AdminLogin() {
  const { login } = useAuth();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    const result = await login(email, password);
    if (!result.ok) setError(result.error || "Não foi possível entrar.");
    setLoading(false);
  };

  return (
    <div className="flex min-h-screen items-center justify-center bg-ivory px-5 grain">
      <div className="w-full max-w-md border border-navy/10 bg-white p-10 shadow-xl" data-testid="admin-login-card">
        <img src="/media/logo.png" alt="Silva Cotan" className="mx-auto h-20 w-auto" />
        <p className="mt-6 text-center text-[11px] font-bold uppercase tracking-[0.25em] text-gold-deep">Área administrativa</p>
        <h1 className="mt-2 text-center font-display text-2xl text-navy">Acesso restrito</h1>
        <form onSubmit={submit} className="mt-8 space-y-5">
          <div>
            <label className="mb-2 block text-[11px] font-bold uppercase tracking-[0.18em] text-navy">E-mail</label>
            <input
              type="email"
              required
              data-testid="admin-login-email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              className="w-full border border-navy/20 bg-ivory/40 px-4 py-3.5 text-sm text-navy focus:border-gold"
              placeholder="E-mail de acesso"
            />
          </div>
          <div>
            <label className="mb-2 block text-[11px] font-bold uppercase tracking-[0.18em] text-navy">Senha</label>
            <input
              type="password"
              required
              data-testid="admin-login-password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              className="w-full border border-navy/20 bg-ivory/40 px-4 py-3.5 text-sm text-navy focus:border-gold"
              placeholder="Senha"
            />
          </div>
          {error && (
            <p className="border border-red-200 bg-red-50 px-4 py-3 text-sm text-red-700" data-testid="admin-login-error">
              {error}
            </p>
          )}
          <button
            type="submit"
            disabled={loading}
            data-testid="admin-login-submit"
            className="inline-flex w-full items-center justify-center gap-3 bg-navy px-6 py-4 text-[11px] font-bold uppercase tracking-[0.22em] text-ivory transition-colors hover:bg-navy-2 disabled:opacity-60"
          >
            <LogIn size={15} /> {loading ? "Entrando…" : "Entrar"}
          </button>
        </form>
        <Link to="/" data-testid="admin-back-site" className="mt-6 flex items-center justify-center gap-2 text-xs text-inkgray transition-colors hover:text-gold-deep">
          <ArrowLeft size={13} /> Voltar ao site
        </Link>
      </div>
    </div>
  );
}
